import { useState, useEffect, useRef } from 'react'
import { keyboardshortcut_talkback } from '../services/Constants'
import ElectronIPC from '../services/ElectronIPC'
import { persistent } from '../services/LocalStorage'
import { ExternalEventEmitter } from '../ExternalEventEmitter'
import { ExternalEvent } from '../AppContext'
import { Button } from '@/UIComponents2/Button'

function RecordKeyView({ onClose }: { onClose: () => void }) {
    const [lastPressedKey, set_lastPressedKey] = useState<{ iohook: number | null; browser: string | null } | null>(
        null
    )

    const containerRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        // Tell the iohook module in the main thread to go into 'listen' mode.
        // Then, it'll start giving us an event for every keystroke, not just the
        // registered ones.
        ElectronIPC.iohookSetMode('listen')
    }, [])

    // All keystrokes will come here.
    useEffect(() => {
        const handler = (externalEvent: ExternalEvent) => {
            if (externalEvent.eventName !== 'global-keydown') {
                return
            }

            // Handle talkback functionality
            const key = externalEvent.value || {}
            if (key) {
                const code = (key.rawcode as number) || null
                set_lastPressedKey({
                    ...lastPressedKey,
                    browser: lastPressedKey?.browser || null,
                    iohook: code,
                })
            }
        }

        ExternalEventEmitter.on('event', handler)

        return () => {
            ExternalEventEmitter.removeListener('event', handler)
        }
    }, [])

    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.focus()
        }
    })

    return (
        <div
            className="flex flex-col w-full gap-5"
            ref={containerRef}
            onKeyDown={(e) => {
                set_lastPressedKey({
                    iohook: lastPressedKey?.iohook || null,
                    // @ts-ignore
                    browser: e.code,
                    // @ts-ignore
                    characterRepresentation: e.key || null,
                })
            }}
            tabIndex={-1}
        >
            <div className="text-[18px]">Press a key...</div>

            <div className="text-[18px]">Key: {lastPressedKey?.browser || ''}</div>

            <div className="flex justify-between items-center gap-1">
                <Button
                    variant="glow"
                    className="py-3 w-full t-base-light"
                    onClick={() => {
                        onClose()
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    className="py-3 w-full"
                    onClick={() => {
                        // Save the key to localStorage.
                        if (lastPressedKey) {
                            persistent.set(keyboardshortcut_talkback, lastPressedKey)
                            if (lastPressedKey.iohook) {
                                ElectronIPC.iohookSetActiveKeys([lastPressedKey.iohook])
                            }
                        }

                        ElectronIPC.iohookSetMode('normal')
                        onClose()
                    }}
                    disabled={lastPressedKey == null}
                >
                    Set
                </Button>
            </div>
        </div>
    )
}

export default RecordKeyView
